import AiPrompt from '@/domain/model/ai/prompt/AiPrompt';

export function createAiChatServiceAuth(domain) {
  return {
    async sendPrompt(params, onMessageReceived, onError, onFinished) {
      if (!domain.value) {
        if (onError) onError('Domain not available in authenticated mode.');
        if (onFinished) onFinished();
        return;
      }
      
      const operation = domain.value.events().ai().prompt(params);
      operation.send((notification) => {
        if (notification.error()) {
          if (onError) onError('Ouch, that question hurt my brain ' + notification.error().hint);
        } else {
          const payload = notification.payload();
          const promptBlob = payload.valuesFor(AiPrompt.MODEL_NAME);
          const prompt = new AiPrompt(domain, promptBlob);
          const responseText = payload.getString("response");
          
          if (onMessageReceived) {
            onMessageReceived({
              id: prompt.isNotNew() ? prompt.id() : '',
              content: responseText,
            });
          }
        }
        if (onFinished) onFinished();
      }, {});
    },

    async savePrompt(messageId, likedValue) {
      if (!domain.value) return;
      
      const params = {
        AiPrompt: messageId,
        liked: likedValue,
      };
      const operation = domain.value.events().ai().save(params);
      operation.send();
    }
  };
}
